import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function SnapshotTabs({ ios = false }: { ios?: boolean }) {
  return (
    <nav aria-label="Snapshot type" className="flex gap-6 border-b">
      {[
        { label: "Xcode", to: "/snapshots", active: !ios },
        { label: "iOS", to: "/snapshots?type=ios", active: ios },
      ].map(({ label, to, active }) => (
        <Link
          key={to}
          to={to}
          aria-current={active ? "page" : undefined}
          className={cn(
            "border-b-2 px-1 py-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            active
              ? "border-foreground font-semibold"
              : "border-transparent text-muted-foreground hover:text-foreground",
          )}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
